import { KalkulatorComponent } from './kalkulator.component';
import { KalkulatorFormModule } from './kalkulator-form/kalkulator-form.module';
import { KalkulatorResultModule } from './kalkulator-result/kalkulator-result.module';
import { KalkulatorVhkModule } from './kalkulator-vhk/kalkulator-vhk.module';
import { KalkulatorService } from './kalkulator.service';
angular
	.module('kalkulator', [KalkulatorFormModule, KalkulatorResultModule, KalkulatorVhkModule])
	.component('kalkulator', KalkulatorComponent)
	.service('KalkulatorService', KalkulatorService);




// WEBPACK FOOTER //
// ../source/application/kalkulator/kalkulator.module.js